import { BehaviorSubject } from 'rxjs';
import { IMenu } from './shared/models/menu';
import { environment } from '@env/environment';

export const menu$ = new BehaviorSubject<IMenu[]>([
  {
    route: "dashboard",
    name: "Dashboard",
    type: "link",
    active: true,
    icon: "home"
  },
  {
    route: "in-home-care",
    name: "In Home Care",
    active: true,
    type: "sub",
    icon: "home_health",
    children: [
      {
        route: "assigned",
        name: "Assigned To Me",
        type: "link",
        active: true
      },
      {
        route: "manage",
        name: "Applications",
        type: "link",
        active: true
      },
      {
        route: "renewal",
        name: "Renewals",
        type: "link",
        active: true
      },
      {
        route: "change",
        name: "Changes",
        type: "link",
        active: true
      },
      {
        route: "ownerClaims",
        name: "Owner Change Claims",
        type: "link",
        active: true
      },
      {
        route: "claims",
        name: "Claim Requests",
        type: "link",
        active: true
      },
      {
        route: "reports",
        name: "Reports/Management",
        type: "link",
        active: true
      },
      {
        route: "complaints/InHomeCareLicense",
        name: "Complaints",
        type: "link",
        active: true
      }
    ]
  },
  {
    route: "hemo-tech",
    name: "Hemodialysis Technician",
    type: "sub",
    active: environment.displayHemotech,
    icon: "bloodtype",
    children: [
      {
        route: "assigned",
        name: "Assigned To Me",
        type: "link",
        active: true
      },
      {
        route: "manage",
        name: "Applications",
        type: "link",
        active: true
      },
      {
        route: "renewal",
        name: "Renewals",
        type: "link",
        active: true
      },
      {
        route: "claims",
        name: "Claim Requests",
        type: "link",
        active: true
      },
      {
        route: "changes",
        name: "Change Requests",
        type: "link",
        active: true
      },
      {
        route: "reports",
        name: "Reports",
        type: "link",
        active: true

      }
    ]
  },
  {
    route: "hospital",
    name: "Hospital / SICF",
    type: "sub",
    active: environment.displayHospitals,
    icon: "local_hospital",
    children: [
      {
        route: "assigned",
        name: "Assigned To Me",
        active: true,
        type: "link"
      },
      {
        route: "manage",
        name: "Applications",
        active: true,
        type: "link"
      },
      {
        route: "renewal",
        name: "Renewals",
        type: "link",
        active: true
      },
      {
        route: "claims",
        name: "Claim Requests",
        type: "link",
        active: true
      },
      {
        route: "admin",
        name: "Admin",
        type: "link",
        active: true
      },
    ]
  },
  {
    route: "user-management",
    name: "User Management",
    type: "link",
    active: true,
    icon: "manage_accounts",
    roles: ['Admin']
  }
]);
